import $ from 'jquery';
import { createApp } from 'vue';

//====--------- import the individual components regardless if they are used inside other components

import PropertyListing from "Vue/components/property-listing/property-listing";
import PropertyCard from "Vue/components/property-card/property-card";

//====--------- each main category needs to be registered with a createApp
const PropertyListingComponent = createApp(PropertyListing);

//====--------- Mount the main category to a unique identifier

if ($('#PropertyListing').length) {
	PropertyListingComponent.component('property-card', PropertyCard);
	PropertyListingComponent.mount('#PropertyListing');
}